// extracted by mini-css-extract-plugin
export default {"ContainerBox":"LinkContainer_ContainerBox__pQ5XY","LinkContainer":"LinkContainer_LinkContainer__8cN0N"};